import { motion } from "framer-motion";

const sVariant = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};
//js fills
const JsVariant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "rgba(0,0,0,1)",
    transition: {
      fill: {
        duration: 0.5,
        delay: 1,
      },
      duration: 2,
      ease: "easeInOut",
    },
  },
};

// ts fills

const TsVariant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(255,255,255,0)",
  },
  visible: {
    pathLength: 1,
    fill: "rgba(255,255,255,1)",
    transition: {
      fill: {
        duration: 0.5,
        delay: 1,
      },
      duration: 2,
      ease: "easeInOut",
    },
  },
};

//next fills

const NextVariant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "rgba(0,0,0,1)",
    transition: {
      fill: {
        duration: 0.5,
        delay: 1,
      },
      duration: 2,
      ease: "easeInOut",
    },
  },
};

//react

const R1Variant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
    stroke: "#53C1DE",
  },
  visible: {
    pathLength: 1,
    fill: "#53C1DE",
    stroke: "rgba(0,0,0,0)",

    transition: {
      fill: {
        duration: 1.2,
        delay: 1,
        ease: "easeInOut",
      },
      stroke: {
        duration: 1,
        delay: 1.5,
        ease: "easeInOut",
      },
      duration: 1.2,
      ease: "easeInOut",
    },
  },
};
const R2Variant = {
  hidden: {
    pathLength: 0,
    fill: "#323841",
    stroke: "#53C1DE",
  },
  visible: {
    pathLength: 1,
    fill: "#323841",
    stroke: "rgba(0,0,0,0)",
    transition: {
      fill: {
        duration: 1,
        delay: 2,
        ease: "easeInOut",
      },
      stroke: {
        duration: 2,
        delay: 2.5,
        ease: "easeInOut",
      },
    },
  },
};
//sass fill
const SassVariant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#CF649A",
    transition: {
      fill: {
        duration: 1,
        delay: 1.5,
      },
      duration: 1.8,
      ease: "easeInOut",
    },
  },
};

const NodeVariant2 = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#539E43",
    transition: {
      fill: {
        duration: 1,
        delay: 1.5,
      },
      duration: 1.8,
      ease: "easeInOut",
    },
  },
};

const NodeVariant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#6CC24A",
    transition: {
      fill: {
        duration: 1,
        delay: 1.5,
      },
      duration: 1.8,
      ease: "easeInOut",
    },
  },
};
const H1Variant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#E44D26",
    transition: {
      fill: {
        duration: 2,
        delay: 1.5,
      },
      duration: 2,
      ease: "circInOut",
    },
  },
};
const H2Variant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#F16529",
    transition: {
      fill: {
        duration: 2,
        delay: 1.5,
      },
      duration: 2,
      ease: "circInOut",
    },
  },
};
const H3Variant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#ebebeb",
    transition: {
      fill: {
        duration: 2,
        delay: 1.5,
      },
      duration: 2,
      ease: "circInOut",
    },
  },
};
const H4Variant = {
  hidden: {
    pathLength: 0,
    fill: "rgba(0,0,0,0)",
  },
  visible: {
    pathLength: 1,
    fill: "#f7f7f7",
    transition: {
      fill: {
        duration: 2,
        delay: 1.2,
      },
      duration: 2,
      ease: "circInOut",
    },
  },
};
const JsIcon = (props) => {
  // console.log(props.anim);
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      // animate={anim}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
    >
      <motion.path d="M0 0h256v256H0V0z" fill="#F7DF1E" />
      <motion.path
        variants={JsVariant}
        fill="none"
        stroke="black"
        d="M67.312 213.932l19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371 7.905 0 12.89-3.092 12.89-15.12v-81.798h24.057v82.138c0 24.917-14.606 36.259-35.916 36.259-19.245 0-30.416-9.967-36.087-21.996M152.381 211.354l19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607 9.969 0 16.325-4.984 16.325-11.858 0-8.248-6.53-11.17-17.528-15.98l-6.013-2.58c-17.357-7.387-28.87-16.667-28.87-36.257 0-18.044 13.747-31.792 35.228-31.792 15.294 0 26.292 5.328 34.196 19.247L210.29 147.43c-4.125-7.389-8.591-10.31-15.465-10.31-7.046 0-11.514 4.468-11.514 10.31 0 7.217 4.468 10.14 14.778 14.608l6.014 2.577c20.45 8.765 31.963 17.7 31.963 37.804 0 21.654-17.012 33.51-39.867 33.51-22.339 0-36.774-10.654-43.819-24.574"
      />
    </motion.svg>
  );
};

//react icon

export const ReactIcon = (props) => {
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      viewBox="0 0 256 230"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
    >
      <motion.path
        fill="none"
        d="M.754 114.75c0 19.215 18.763 37.152 48.343 47.263-5.907 29.737-1.058 53.706 15.136 63.045 16.645 9.6 41.443 2.955 64.98-17.62 22.943 19.744 46.13 27.514 62.31 18.148 16.63-9.627 21.687-35.221 15.617-65.887 30.81-10.186 48.044-25.481 48.044-44.949 0-18.769-18.797-35.006-47.979-45.052 6.535-31.933.998-55.32-15.867-65.045-16.259-9.376-39.716-1.204-62.996 19.056C104.122 2.205 80.897-4.36 64.05 5.392 47.806 14.795 43.171 39.2 49.097 69.487 20.515 79.452.754 96.057.754 114.75z"
      />
      <motion.path
        variants={R1Variant}
        fill="none"
        stroke="black"
        d="M201.025 79.674a151.364 151.364 0 0 0-7.274-2.292 137.5 137.5 0 0 0 1.124-4.961c5.506-26.728 1.906-48.26-10.388-55.348-11.787-6.798-31.065.29-50.535 17.233a151.136 151.136 0 0 0-5.626 5.163 137.573 137.573 0 0 0-3.744-3.458c-20.405-18.118-40.858-25.752-53.139-18.643-11.776 6.817-15.264 27.06-10.307 52.39a150.91 150.91 0 0 0 1.67 7.484c-2.894.822-5.689 1.698-8.363 2.63-23.922 8.34-39.2 21.412-39.2 34.97 0 14.004 16.4 28.05 41.318 36.566a128.44 128.44 0 0 0 6.11 1.91 147.813 147.813 0 0 0-1.775 8.067c-4.726 24.89-1.035 44.653 10.71 51.428 12.131 6.995 32.491-.195 52.317-17.525 1.567-1.37 3.14-2.823 4.715-4.346a148.34 148.34 0 0 0 6.108 5.573c19.204 16.525 38.17 23.198 49.905 16.405 12.12-7.016 16.058-28.247 10.944-54.078-.39-1.973-.845-3.988-1.355-6.04 1.43-.422 2.833-.858 4.202-1.312 25.904-8.582 42.757-22.457 42.757-36.648 0-13.607-15.77-26.767-40.174-35.168z"
        // fill="#53C1DE"
      />
      <motion.path
        variants={R2Variant}
        fill="none"
        stroke="black"
        d="M195.406 142.328c-1.235.409-2.503.804-3.795 1.187-2.86-9.053-6.72-18.68-11.442-28.625 4.507-9.71 8.217-19.213 10.997-28.208 2.311.67 4.555 1.375 6.717 2.12 20.91 7.197 33.664 17.84 33.664 26.04 0 8.735-13.775 20.075-36.14 27.486zm-9.28 18.389c2.261 11.422 2.584 21.749 1.086 29.822-1.346 7.254-4.052 12.09-7.398 14.027-7.121 4.122-22.35-1.236-38.772-15.368-1.883-1.62-3.78-3.35-5.682-5.18 6.367-6.964 12.73-15.06 18.94-24.05 10.924-.969 21.244-2.554 30.603-4.717.46 1.86.87 3.683 1.223 5.466zm-93.85 43.137c-6.957 2.457-12.498 2.527-15.847.596-7.128-4.11-10.09-19.98-6.049-41.265a138.507 138.507 0 0 1 1.65-7.502c9.255 2.047 19.5 3.52 30.45 4.408 6.251 8.797 12.798 16.883 19.396 23.964a118.863 118.863 0 0 1-4.305 3.964c-8.767 7.664-17.552 13.1-25.294 15.835zm-32.593-61.58c-11.018-3.766-20.117-8.66-26.354-14-5.604-4.8-8.434-9.565-8.434-13.432 0-8.227 12.267-18.722 32.726-25.855a139.276 139.276 0 0 1 7.777-2.447c2.828 9.197 6.537 18.813 11.013 28.537-4.534 9.869-8.296 19.638-11.15 28.943a118.908 118.908 0 0 1-5.578-1.746zm10.926-74.37c-4.247-21.703-1.427-38.074 5.67-42.182 7.56-4.376 24.275 1.864 41.893 17.507 1.126 1 2.257 2.047 3.39 3.13-6.564 7.049-13.051 15.074-19.248 23.82-10.627.985-20.8 2.567-30.152 4.686a141.525 141.525 0 0 1-1.553-6.962zm97.467 24.067a306.982 306.982 0 0 0-6.871-11.3c7.21.91 14.117 2.12 20.603 3.601-1.947 6.241-4.374 12.767-7.232 19.457a336.42 336.42 0 0 0-6.5-11.758zm-39.747-38.714c4.452 4.823 8.911 10.209 13.297 16.052a284.245 284.245 0 0 0-26.706-.006c4.39-5.789 8.887-11.167 13.409-16.046zm-40.002 38.78a285.24 285.24 0 0 0-6.378 11.685c-2.811-6.667-5.216-13.222-7.18-19.552 6.447-1.443 13.322-2.622 20.485-3.517a283.79 283.79 0 0 0-6.927 11.384zm7.133 57.683c-7.4-.826-14.379-1.945-20.824-3.348 1.995-6.442 4.453-13.138 7.324-19.948a283.494 283.494 0 0 0 6.406 11.692 285.27 285.27 0 0 0 7.094 11.604zm33.136 27.389c-4.575-4.937-9.138-10.397-13.595-16.27 4.326.17 8.737.256 13.22.256 4.606 0 9.159-.103 13.64-.303-4.4 5.98-8.843 11.448-13.265 16.317zm46.072-51.032c3.02 6.884 5.566 13.544 7.588 19.877-6.552 1.495-13.625 2.699-21.078 3.593a337.537 337.537 0 0 0 6.937-11.498 306.632 306.632 0 0 0 6.553-11.972zm-14.915 7.15a316.478 316.478 0 0 1-10.84 17.49c-6.704.479-13.632.726-20.692.726-7.031 0-13.871-.219-20.458-.646A273.798 273.798 0 0 1 96.72 133.28a271.334 271.334 0 0 1-9.64-18.206 273.864 273.864 0 0 1 9.611-18.216v.002a271.252 271.252 0 0 1 10.956-17.442c6.72-.508 13.61-.774 20.575-.774 6.996 0 13.895.268 20.613.78a290.704 290.704 0 0 1 10.887 17.383 316.418 316.418 0 0 1 9.741 18.13 290.806 290.806 0 0 1-9.709 18.29zm19.913-107.792c7.566 4.364 10.509 21.961 5.755 45.038a127.525 127.525 0 0 1-1.016 4.492c-9.374-2.163-19.554-3.773-30.212-4.773-6.209-8.841-12.642-16.88-19.1-23.838a141.92 141.92 0 0 1 5.196-4.766c16.682-14.518 32.273-20.25 39.377-16.153z"
        // fill="#FFF"
      />
      <motion.path
        variants={R1Variant}
        fill="none"
        stroke="black"
        d="M128.221 94.665c11.144 0 20.177 9.034 20.177 20.177 0 11.144-9.033 20.178-20.177 20.178-11.143 0-20.177-9.034-20.177-20.178 0-11.143 9.034-20.177 20.177-20.177"
      />
    </motion.svg>
  );
};

//sass
export const SassIcon = (props) => {
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 384"
    >
      <motion.path
        variants={SassVariant}
        fill="none"
        stroke="#CF649A"
        d="M440.6 220.6c-17.9.101-33.4 4.4-46.4 10.801-4.8-9.5-9.6-17.801-10.399-24-.9-7.2-2-11.601-.9-20.2C384 178.6 389 166.4 389 165.4c-.101-.9-1.101-5.3-11.4-5.4s-19.2 2-20.2 4.7-3 8.9-4.3 15.3c-1.8 9.4-20.6 42.7-31.3 60.2-3.5-6.8-6.5-12.8-7.101-17.601-.899-7.199-2-11.6-.899-20.199 1.1-8.601 6.1-20.8 6.1-21.8-.1-.9-1.1-5.3-11.399-5.4-10.301-.1-19.2 2-20.2 4.7s-2.1 9.1-4.3 15.3C281.9 201.4 256.9 257 250.4 271.5c-3.3 7.4-6.199 13.3-8.3 17.3-2.1 4-.1.3-.3.7-1.8 3.4-2.8 5.3-2.8 5.3v.101c-1.4 2.5-2.9 4.899-3.601 4.899-.5 0-1.5-6.7.2-15.899 3.7-19.301 12.7-49.4 12.601-50.5 0-.5 1.699-5.801-5.801-8.5-7.3-2.7-9.899 1.8-10.5 1.8-.6 0-1.1 1.6-1.1 1.6s8.1-33.899-15.5-33.899c-14.8 0-35.2 16.1-45.3 30.8-6.4 3.5-20 10.899-34.4 18.8-5.5 3-11.2 6.2-16.6 9.1L117.9 251.9c-28.6-30.5-81.5-52.1-79.3-93.1.8-14.9 6-54.2 101.601-101.8 78.3-39 141-28.3 151.899-4.5 15.5 34-33.5 97.2-114.899 106.3-31 3.5-47.301-8.5-51.4-13-4.3-4.7-4.9-4.9-6.5-4-2.6 1.4-1 5.6 0 8.1 2.4 6.3 12.4 17.5 29.4 23.1 14.899 4.9 51.3 7.6 95.3-9.4 49.3-19.1 87.8-72.1 76.5-116.4-11.5-45.1-86.3-59.9-157-34.8C121.4 27.4 75.8 50.8 43 81.5 4 117.9-2.2 149.7.4 162.9c9.101 47.1 74 77.8 100 100.5-1.3.699-2.5 1.399-3.6 2-13 6.399-62.5 32.3-74.9 59.699-14 31 2.2 53.301 13 56.301 33.4 9.3 67.6-7.4 86.1-34.9 18.399-27.5 16.2-63.2 7.7-79.5l-.301-.6 10.2-6c6.601-3.9 13.101-7.5 18.8-10.601-3.199 8.7-5.5 19-6.699 34-1.4 17.601 5.8 40.4 15.3 49.4 4.2 3.899 9.2 4 12.3 4 11 0 16-9.101 21.5-20 6.8-13.3 12.8-28.7 12.8-28.7s-7.5 41.7 13 41.7c7.5 0 15-9.7 18.4-14.7v.1s.2-.3.6-1a36.13 36.13 0 0 0 1.2-1.899v-.2c3-5.2 9.7-17.1 19.7-36.8 12.899-25.4 25.3-57.2 25.3-57.2s1.2 7.8 4.9 20.6c2.199 7.601 6.999 15.9 10.699 24-3 4.2-4.8 6.601-4.8 6.601l.1.1c-2.399 3.2-5.1 6.601-7.899 10-10.2 12.2-22.4 26.101-24 30.101-1.9 4.699-1.5 8.199 2.2 11 2.7 2 7.5 2.399 12.6 2 9.2-.601 15.6-2.9 18.8-4.301 5-1.8 10.7-4.5 16.2-8.5 10-7.399 16.1-17.899 15.5-31.899-.3-7.7-2.8-15.3-5.9-22.5.9-1.3 1.801-2.601 2.7-4 15.8-23.101 28-48.5 28-48.5s1.2 7.8 4.9 20.6c1.899 6.5 5.7 13.601 9.1 20.601-14.8 12.1-24.1 26.1-27.3 35.3-5.9 17-1.3 24.7 7.4 26.5 3.899.8 9.5-1 13.699-2.8 5.2-1.7 11.5-4.601 17.301-8.9 10-7.4 19.6-17.7 19.1-31.6-.3-6.4-2-12.7-4.3-18.7 12.6-5.2 28.899-8.2 49.6-5.7 44.5 5.2 53.3 33 51.601 44.6-1.7 11.601-11 18-14.101 20-3.1 1.9-4.1 2.601-3.8 4 .4 2.101 1.8 2 4.5 1.601 3.7-.601 23.4-9.5 24.2-30.899 1.2-27.504-24.9-57.504-71.2-57.205zM97.4 336.3c-14.7 16.1-35.4 22.2-44.2 17-9.5-5.5-5.801-29.2 12.3-46.3 11-10.4 25.3-20 34.7-25.9 2.1-1.3 5.3-3.199 9.1-5.5.6-.399 1-.6 1-.6.7-.4 1.5-.9 2.3-1.4 6.7 24.4.3 45.8-15.2 62.7zm107.5-73.1c-5.1 12.5-15.9 44.6-22.4 42.8-5.601-1.5-9-25.8-1.101-49.8 4-12.101 12.5-26.5 17.5-32.101 8.101-9 16.9-12 19.101-8.3 2.6 4.801-9.9 39.601-13.1 47.401zm88.7 42.4c-2.2 1.101-4.2 1.9-5.1 1.301-.7-.4.899-1.9.899-1.9s11.1-11.9 15.5-17.4c2.5-3.199 5.5-6.899 8.7-11.1v1.2C313.6 292.1 299.8 301.7 293.6 305.6zm68.399-15.6c-1.6-1.2-1.399-4.9 4-16.5 2.101-4.6 6.9-12.3 15.2-19.6 1 3 1.601 5.899 1.5 8.6-.099 18-12.899 24.7-20.7 27.5z"
      />
    </motion.svg>
  );
};

export const SassNoAnim = (props) => {
  return (
    <svg
      initial="hidden"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 384"
    >
      <path
        fill="#CF649A"
        stroke="#CF649A"
        d="M440.6 220.6c-17.9.101-33.4 4.4-46.4 10.801-4.8-9.5-9.6-17.801-10.399-24-.9-7.2-2-11.601-.9-20.2C384 178.6 389 166.4 389 165.4c-.101-.9-1.101-5.3-11.4-5.4s-19.2 2-20.2 4.7-3 8.9-4.3 15.3c-1.8 9.4-20.6 42.7-31.3 60.2-3.5-6.8-6.5-12.8-7.101-17.601-.899-7.199-2-11.6-.899-20.199 1.1-8.601 6.1-20.8 6.1-21.8-.1-.9-1.1-5.3-11.399-5.4-10.301-.1-19.2 2-20.2 4.7s-2.1 9.1-4.3 15.3C281.9 201.4 256.9 257 250.4 271.5c-3.3 7.4-6.199 13.3-8.3 17.3-2.1 4-.1.3-.3.7-1.8 3.4-2.8 5.3-2.8 5.3v.101c-1.4 2.5-2.9 4.899-3.601 4.899-.5 0-1.5-6.7.2-15.899 3.7-19.301 12.7-49.4 12.601-50.5 0-.5 1.699-5.801-5.801-8.5-7.3-2.7-9.899 1.8-10.5 1.8-.6 0-1.1 1.6-1.1 1.6s8.1-33.899-15.5-33.899c-14.8 0-35.2 16.1-45.3 30.8-6.4 3.5-20 10.899-34.4 18.8-5.5 3-11.2 6.2-16.6 9.1L117.9 251.9c-28.6-30.5-81.5-52.1-79.3-93.1.8-14.9 6-54.2 101.601-101.8 78.3-39 141-28.3 151.899-4.5 15.5 34-33.5 97.2-114.899 106.3-31 3.5-47.301-8.5-51.4-13-4.3-4.7-4.9-4.9-6.5-4-2.6 1.4-1 5.6 0 8.1 2.4 6.3 12.4 17.5 29.4 23.1 14.899 4.9 51.3 7.6 95.3-9.4 49.3-19.1 87.8-72.1 76.5-116.4-11.5-45.1-86.3-59.9-157-34.8C121.4 27.4 75.8 50.8 43 81.5 4 117.9-2.2 149.7.4 162.9c9.101 47.1 74 77.8 100 100.5-1.3.699-2.5 1.399-3.6 2-13 6.399-62.5 32.3-74.9 59.699-14 31 2.2 53.301 13 56.301 33.4 9.3 67.6-7.4 86.1-34.9 18.399-27.5 16.2-63.2 7.7-79.5l-.301-.6 10.2-6c6.601-3.9 13.101-7.5 18.8-10.601-3.199 8.7-5.5 19-6.699 34-1.4 17.601 5.8 40.4 15.3 49.4 4.2 3.899 9.2 4 12.3 4 11 0 16-9.101 21.5-20 6.8-13.3 12.8-28.7 12.8-28.7s-7.5 41.7 13 41.7c7.5 0 15-9.7 18.4-14.7v.1s.2-.3.6-1a36.13 36.13 0 0 0 1.2-1.899v-.2c3-5.2 9.7-17.1 19.7-36.8 12.899-25.4 25.3-57.2 25.3-57.2s1.2 7.8 4.9 20.6c2.199 7.601 6.999 15.9 10.699 24-3 4.2-4.8 6.601-4.8 6.601l.1.1c-2.399 3.2-5.1 6.601-7.899 10-10.2 12.2-22.4 26.101-24 30.101-1.9 4.699-1.5 8.199 2.2 11 2.7 2 7.5 2.399 12.6 2 9.2-.601 15.6-2.9 18.8-4.301 5-1.8 10.7-4.5 16.2-8.5 10-7.399 16.1-17.899 15.5-31.899-.3-7.7-2.8-15.3-5.9-22.5.9-1.3 1.801-2.601 2.7-4 15.8-23.101 28-48.5 28-48.5s1.2 7.8 4.9 20.6c1.899 6.5 5.7 13.601 9.1 20.601-14.8 12.1-24.1 26.1-27.3 35.3-5.9 17-1.3 24.7 7.4 26.5 3.899.8 9.5-1 13.699-2.8 5.2-1.7 11.5-4.601 17.301-8.9 10-7.4 19.6-17.7 19.1-31.6-.3-6.4-2-12.7-4.3-18.7 12.6-5.2 28.899-8.2 49.6-5.7 44.5 5.2 53.3 33 51.601 44.6-1.7 11.601-11 18-14.101 20-3.1 1.9-4.1 2.601-3.8 4 .4 2.101 1.8 2 4.5 1.601 3.7-.601 23.4-9.5 24.2-30.899 1.2-27.504-24.9-57.504-71.2-57.205zM97.4 336.3c-14.7 16.1-35.4 22.2-44.2 17-9.5-5.5-5.801-29.2 12.3-46.3 11-10.4 25.3-20 34.7-25.9 2.1-1.3 5.3-3.199 9.1-5.5.6-.399 1-.6 1-.6.7-.4 1.5-.9 2.3-1.4 6.7 24.4.3 45.8-15.2 62.7zm107.5-73.1c-5.1 12.5-15.9 44.6-22.4 42.8-5.601-1.5-9-25.8-1.101-49.8 4-12.101 12.5-26.5 17.5-32.101 8.101-9 16.9-12 19.101-8.3 2.6 4.801-9.9 39.601-13.1 47.401zm88.7 42.4c-2.2 1.101-4.2 1.9-5.1 1.301-.7-.4.899-1.9.899-1.9s11.1-11.9 15.5-17.4c2.5-3.199 5.5-6.899 8.7-11.1v1.2C313.6 292.1 299.8 301.7 293.6 305.6zm68.399-15.6c-1.6-1.2-1.399-4.9 4-16.5 2.101-4.6 6.9-12.3 15.2-19.6 1 3 1.601 5.899 1.5 8.6-.099 18-12.899 24.7-20.7 27.5z"
      />
    </svg>
  );
};

export const NodeIcon = (props) => {
  return (
    <motion.svg
      style={{ marginLeft: "-30px" }}
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      viewBox="0 0 256 289"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.path
        variants={NodeVariant2}
        d="M127.999999,288.463771 C124.024844,288.463771 120.314699,287.403728 116.869564,285.548656 L81.6231884,264.612838 C76.32298,261.697724 78.9730854,260.637682 80.5631458,260.107661 C87.7184259,257.72257 89.0434775,257.192547 96.4637688,252.952381 C97.2587979,252.422361 98.3188405,252.687372 99.1138718,253.217392 L126.144927,269.383024 C127.20497,269.913045 128.530021,269.913045 129.325053,269.383024 L235.064182,208.165634 C236.124225,207.635611 236.654245,206.575571 236.654245,205.250519 L236.654245,83.0807467 C236.654245,81.7556929 236.124225,80.6956526 235.064182,80.1656324 L129.325053,19.2132506 C128.26501,18.6832305 126.939959,18.6832305 126.144927,19.2132506 L20.4057954,80.1656324 C19.3457551,80.6956526 18.8157349,82.0207041 18.8157349,83.0807467 L18.8157349,205.250519 C18.8157349,206.31056 19.3457551,207.635611 20.4057954,208.165634 L49.2919247,224.861286 C64.9275364,232.811595 74.7329196,223.536234 74.7329196,214.260871 L74.7329196,93.681159 C74.7329196,92.0910985 76.0579711,90.5010358 77.9130428,90.5010358 L91.4285716,90.5010358 C93.0186343,90.5010358 94.6086948,91.8260873 94.6086948,93.681159 L94.6086948,214.260871 C94.6086948,235.196689 83.2132512,247.387164 63.3374737,247.387164 C57.2422362,247.387164 52.4720502,247.387164 38.9565214,240.761906 L11.1304347,224.861286 C4.24016581,220.886129 5.68434189e-14,213.46584 5.68434189e-14,205.515528 L5.68434189e-14,83.3457557 C5.68434189e-14,75.3954465 4.24016581,67.9751552 11.1304347,64.0000006 L116.869564,2.78260752 C123.494824,-0.927535841 132.505176,-0.927535841 139.130436,2.78260752 L244.869565,64.0000006 C251.759834,67.9751552 256,75.3954465 256,83.3457557 L256,205.515528 C256,213.46584 251.759834,220.886129 244.869565,224.861286 L139.130436,286.078676 C135.685299,287.668739 131.710145,288.463771 127.999999,288.463771 L127.999999,288.463771 Z M160.596274,204.455488 C114.219461,204.455488 104.679089,183.254659 104.679089,165.233955 C104.679089,163.643893 106.004141,162.053832 107.859212,162.053832 L121.639752,162.053832 C123.229813,162.053832 124.554864,163.113872 124.554864,164.703935 C126.674947,178.749484 132.770187,185.639753 160.861283,185.639753 C183.122154,185.639753 192.662526,180.604556 192.662526,168.67909 C192.662526,161.788821 190.012423,156.753624 155.296065,153.308489 C126.409938,150.393375 108.389235,144.033126 108.389235,120.977226 C108.389235,99.5113875 126.409938,86.7908901 156.621119,86.7908901 C190.542443,86.7908901 207.238095,98.4513472 209.358178,123.89234 C209.358178,124.687371 209.093167,125.482403 208.563147,126.277434 C208.033127,126.807454 207.238095,127.337474 206.443064,127.337474 L192.662526,127.337474 C191.337475,127.337474 190.012423,126.277434 189.747412,124.952382 C186.567289,110.376813 178.351966,105.606625 156.621119,105.606625 C132.240165,105.606625 129.325053,114.086957 129.325053,120.447205 C129.325053,128.132506 132.770187,130.5176 165.631471,134.757766 C198.227744,138.997931 213.598344,145.093169 213.598344,167.884058 C213.333333,191.20497 194.252589,204.455488 160.596274,204.455488 L160.596274,204.455488 Z"
        fill="none"
        stroke="#539E43"
      />
    </motion.svg>
  );
};

export const TsIcon = (props) => {
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      preserveAspectRatio="xMinYMin meet"
    >
      <motion.path fill="#007ACB" d="M0 200V0h400v400H0" />
      <motion.path
        variants={TsVariant}
        fill="none"
        stroke="black"
        d="M87.7 200.7V217h52v148h36.9V217h52v-16c0-9 0-16.3-.4-16.5 0-.3-31.7-.4-70.2-.4l-70 .3v16.4l-.3-.1zM321.4 184c10.2 2.4 18 7 25 14.3 3.7 4 9.2 11 9.6 12.8 0 .6-17.3 12.3-27.8 18.8-.4.3-2-1.4-3.6-4-5.2-7.4-10.5-10.6-18.8-11.2-12-.8-20 5.5-20 16 0 3.2.6 5 1.8 7.6 2.7 5.5 7.7 8.8 23.2 15.6 28.6 12.3 41 20.4 48.5 32 8.5 13 10.4 33.4 4.7 48.7-6.4 16.7-22 28-44.3 31.7-7 1.2-23 1-30.5-.3-16-3-31.3-11-40.7-21.3-3.7-4-10.8-14.7-10.4-15.4l3.8-2.4 15-8.7 11.3-6.6 2.6 3.5c3.3 5.2 10.7 12.2 15 14.6 13 6.7 30.4 5.8 39-2 3.7-3.4 5.3-7 5.3-12 0-4.6-.7-6.7-3-10.2-3.2-4.4-9.6-8-27.6-16-20.7-8.8-29.5-14.4-37.7-23-4.7-5.2-9-13.3-11-20-1.5-5.8-2-20-.6-25.7 4.3-20 19.4-34 41-38 7-1.4 23.5-.8 30.4 1l-.2.2z"
      />
    </motion.svg>
  );
};

//nextjs icon

export const NextIcon = (props) => {
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      viewBox="0 0 207 124"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Black-Next.js"
          transform="translate(-247.000000, -138.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="next-black" transform="translate(247.000000, 138.000000)">
            <g id="EXT-+-Type-something">
              <motion.path
                variants={NextVariant}
                fill="none"
                stroke="black"
                d="M48.9421964,32.6320058 L87.9011585,32.6320058 L87.9011585,35.7136421 L52.5134345,35.7136421 L52.5134345,58.9070103 L85.7908813,58.9070103 L85.7908813,61.9886466 L52.5134345,61.9886466 L52.5134345,87.4526941 L88.306981,87.4526941 L88.306981,90.5343303 L48.9421964,90.5343303 L48.9421964,32.6320058 Z M91.3912326,32.6320058 L95.5306221,32.6320058 L113.8738,58.0960534 L132.622801,32.6320058 L158.124498,0.286809811 L116.22757,60.7722112 L137.817329,90.5343303 L133.51561,90.5343303 L113.8738,63.4483691 L94.1508254,90.5343303 L89.9302715,90.5343303 L111.682358,60.7722112 L91.3912326,32.6320058 Z M139.359455,35.713642 L139.359455,32.6320058 L183.756439,32.6320058 L183.756439,35.7136421 L163.302983,35.7136421 L163.302983,90.5343303 L159.731745,90.5343303 L159.731745,35.7136421 L139.359455,35.713642 Z"
                id="EXT"
              ></motion.path>
              <motion.polygon
                variants={NextVariant}
                fill="none"
                stroke="black"
                id="Type-something"
                points="0.202923647 32.6320058 4.66697141 32.6320058 66.2235778 124.303087 40.785176 90.5343303 3.93649086 37.0111732 3.77416185 90.5343303 0.202923647 90.5343303"
              ></motion.polygon>
            </g>
            <motion.path
              variants={NextVariant}
              fill="none"
              stroke="black"
              d="M183.396622,86.5227221 C184.134938,86.5227221 184.673474,85.9601075 184.673474,85.233037 C184.673474,84.5059658 184.134938,83.9433513 183.396622,83.9433513 C182.666993,83.9433513 182.11977,84.5059658 182.11977,85.233037 C182.11977,85.9601075 182.666993,86.5227221 183.396622,86.5227221 Z M186.905793,83.1297235 C186.905793,85.2763149 188.460599,86.678523 190.727662,86.678523 C193.142388,86.678523 194.601647,85.233037 194.601647,82.7229099 L194.601647,73.8855335 L192.655968,73.8855335 L192.655968,82.7142542 C192.655968,84.1078073 191.952397,84.8521899 190.710289,84.8521899 C189.598473,84.8521899 188.842785,84.1597409 188.816727,83.1297235 L186.905793,83.1297235 Z M197.146664,83.0172011 C197.285642,85.2503478 199.153145,86.678523 201.932686,86.678523 C204.903321,86.678523 206.762139,85.1811034 206.762139,82.792155 C206.762139,80.9138876 205.702439,79.8752151 203.131364,79.2779777 L201.750279,78.9404092 C200.117298,78.5595622 199.457158,78.0488813 199.457158,77.1573541 C199.457158,76.0321243 200.482113,75.296398 202.019547,75.296398 C203.478806,75.296398 204.48639,76.0148135 204.668797,77.1660091 L206.562359,77.1660091 C206.44944,75.0626962 204.590622,73.5825873 202.045605,73.5825873 C199.309495,73.5825873 197.48542,75.0626962 197.48542,77.2871878 C197.48542,79.1221767 198.519063,80.2127835 200.786126,80.7407758 L202.401734,81.1302779 C204.060773,81.5197807 204.790402,82.091051 204.790402,83.0431676 C204.790402,84.1510859 203.643842,84.9560573 202.08035,84.9560573 C200.403939,84.9560573 199.240006,84.2030196 199.074971,83.0172011 L197.146664,83.0172011 Z"
              id=".JS"
            ></motion.path>
          </g>
        </g>
      </g>
    </motion.svg>
  );
};

//HTml icon
export const HtmlIcon = (props) => {
  return (
    <motion.svg
      variants={sVariant}
      animate={props.anim}
      initial="hidden"
      viewBox="0 0 256 361"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
    >
      <motion.path
        variants={H1Variant}
        fill="none"
        stroke="black"
        d="M255.555 70.766l-23.241 260.36-104.47 28.962-104.182-28.922L.445 70.766h255.11z"
        // fill="#E44D26"
      />
      <motion.path
        d="M128 337.95l84.417-23.403 19.86-222.49H128V337.95z"
        // fill="#F16529"
        variants={H2Variant}
        fill="none"
        stroke="black"
      />
      <motion.path
        variants={H3Variant}
        fill="none"
        stroke="black"
        d="M82.82 155.932H128v-31.937H47.917l.764 8.568 7.85 88.01H128v-31.937H85.739l-2.919-32.704zM90.018 236.542h-32.06l4.474 50.146 65.421 18.16.147-.04V271.58l-.14.037-35.568-9.604-2.274-25.471z"
        // fill="#EBEBEB"
      />
      <motion.path
        fill="none"
        stroke="black"
        d="M24.18 0h16.23v16.035h14.847V0h16.231v48.558h-16.23v-16.26H40.411v16.26h-16.23V0zM92.83 16.103H78.544V0h44.814v16.103h-14.295v32.455h-16.23V16.103h-.001zM130.47 0h16.923l10.41 17.062L168.203 0h16.93v48.558h-16.164V24.49l-11.166 17.265h-.28L146.35 24.49v24.068h-15.88V0zM193.21 0h16.235v32.508h22.824v16.05h-39.06V0z"
      />
      <motion.path
        variants={H4Variant}
        fill="none"
        stroke="black"
        d="M127.89 220.573h39.327l-3.708 41.42-35.62 9.614v33.226l65.473-18.145.48-5.396 7.506-84.08.779-8.576H127.89v31.937zM127.89 155.854v.078h77.143l.64-7.178 1.456-16.191.763-8.568H127.89v31.86z"
      />
    </motion.svg>
  );
};

export const Materialize = () => {
  return (
    <svg
      viewBox="0 0 256 131"
      version="1.1"
      width="100%"
      height="50px"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <g strokeWidth="0.09375">
          <path
            d="M63.1816647,4.19975875 C64.108082,2.62484922 65.3124246,1.11170084 67.041737,0.370566948 C67.7519903,0.247044632 68.4622437,0.30880579 69.172497,0.30880579 L104.129312,0.30880579 C103.110253,1.173462 102.122075,2.06899879 101.442702,3.2424608 C99.6516285,6.1761158 98.4472859,9.44945718 97.335585,12.7227986 C94.185766,22.6045838 91.9932449,32.7642943 89.8624849,42.9240048 C88.905187,47.5252111 87.9787696,52.1572979 87.1141134,56.7585042 C84.4583836,71.8282268 81.7100121,86.8670688 78.2822678,101.782388 C76.6455971,108.668758 74.9780458,115.555127 72.4458384,122.194451 C71.2723764,124.942823 70.1297949,127.876478 67.8755127,129.914596 C67.3505428,130.377805 66.825573,130.964536 66.0844391,130.871894 L35.2038601,130.871894 C33.1039807,130.810133 31.0349819,130.995416 28.9351025,130.779252 C30.3247286,129.698432 31.5599517,128.401448 32.3628468,126.857419 C34.6788902,122.441496 36.1302774,117.655006 37.5199035,112.899397 C39.681544,105.241013 41.4108565,97.4899879 43.0475271,89.7389626 C44.0665862,84.6436671 45.2709288,79.5792521 46.0120627,74.453076 C46.8458384,68.7401689 48.1119421,63.0890229 49.1310012,57.4069964 C50.7367913,49.0383595 52.4352232,40.6697226 54.3189385,32.3628468 C55.8320869,25.8779252 57.3761158,19.4238842 59.4451146,13.0933655 C60.4641737,10.0361882 61.5758745,7.00989144 63.1816647,4.19975875 Z"
            stroke="#EB7077"
            fill="#EB7077"
          ></path>
          <path
            d="M104.129312,0.30880579 C105.024849,0.30880579 105.920386,0.277925211 106.815923,0.30880579 C108.79228,1.35874548 110.459831,3.02629674 111.386248,5.09529554 C112.621472,7.44221954 113.640531,9.91266586 114.566948,12.4448733 C117.655006,21.9869723 119.754885,31.8069964 121.854765,41.5961399 C123.645838,50.3662244 125.34427,59.1671894 126.95006,67.999035 C127.073583,68.4622437 126.91918,69.1107358 127.536791,69.2342581 C125.31339,80.8453559 123.120869,92.4873341 120.341616,104.00579 C118.828468,110.212786 117.222678,116.388902 114.937515,122.379735 C113.702292,125.375151 112.436188,128.648492 109.811339,130.779252 C108.143788,131.149819 106.939445,129.883715 105.920386,128.741134 C104.160193,126.486852 103.079373,123.831122 102.029433,121.175392 C98.5399276,111.664174 96.4091677,101.751508 94.2475271,91.8697226 C92.6108565,84.1804584 91.1594692,76.4294331 89.6463209,68.7092883 C88.9669481,64.7874548 88.0405308,60.9273824 87.5155609,57.0055489 C87.4229192,56.9437877 87.2067551,56.8202654 87.1141134,56.7585042 C87.9787696,52.1572979 88.905187,47.5252111 89.8624849,42.9240048 C91.9932449,32.7642943 94.185766,22.6045838 97.335585,12.7227986 C98.4472859,9.44945718 99.6516285,6.1761158 101.442702,3.2424608 C102.122075,2.06899879 103.110253,1.173462 104.129312,0.30880579 Z"
            stroke="#F6A2AD"
            fill="#F6A2AD"
          ></path>
          <path
            d="M142.760917,5.65114596 C143.872618,3.52038601 145.231363,1.14258142 147.640048,0.339686369 C159.899638,0.277925211 172.159228,0.30880579 184.418818,0.30880579 C183.276236,1.45138721 182.071894,2.59396864 181.299879,4.04535585 C178.922075,8.30687575 177.532449,13.0316043 176.111942,17.6945718 C172.468034,30.5408926 169.904946,43.6651387 167.46538,56.7893848 C165.211098,69.7283474 162.802413,82.66731 160.054041,95.5445115 C158.633534,102.029433 157.151267,108.483474 155.267551,114.875754 C154.063209,118.828468 152.797105,122.812063 150.820748,126.486852 C149.86345,128.154403 148.751749,129.976357 146.929795,130.841013 C135.226055,130.933655 123.491435,130.841013 111.787696,130.871894 C111.139204,130.871894 110.459831,130.871894 109.811339,130.779252 C112.436188,128.648492 113.702292,125.375151 114.937515,122.379735 C117.222678,116.388902 118.828468,110.212786 120.341616,104.00579 C123.120869,92.4873341 125.31339,80.8453559 127.536791,69.2342581 C130.223402,54.2571773 133.033534,39.2800965 136.615682,24.4882992 C138.283233,18.0960193 139.889023,11.6110977 142.760917,5.65114596 Z"
            stroke="#EB7077"
            fill="#EB7077"
          ></path>
          <path
            d="M184.418818,0.30880579 C185.406996,0.30880579 186.426055,0.277925211 187.414234,0.30880579 C189.020024,1.14258142 190.162606,2.56308806 191.181665,4.01447527 C192.849216,6.67020507 193.899156,9.66562123 194.979976,12.5992762 C197.543064,20.4738239 199.45766,28.5645356 201.217853,36.6552473 C203.564777,47.5560917 205.602895,58.5186972 207.610133,69.4813028 C208.104222,72.106152 208.598311,74.7618818 208.907117,77.4176116 C209.030639,77.5411339 209.277684,77.7881785 209.370326,77.8808203 C208.258625,79.4248492 207.826297,81.277684 207.208685,83.037877 C205.263209,89.3066345 203.997105,95.7915561 202.916285,102.245597 C202.082509,107.310012 200.939928,112.343546 199.365018,117.222678 C198.191556,120.835706 196.771049,124.417853 194.424125,127.44415 C193.312425,128.895537 191.799276,130.007238 190.131725,130.748372 C187.568637,131.026297 186.055489,128.55585 184.820265,126.733896 C182.257177,122.256212 180.867551,117.253559 179.385283,112.374427 C174.506152,94.3092883 171.325452,75.8118215 167.897708,57.437877 C167.866828,57.1599517 167.712425,56.9129071 167.46538,56.7893848 C169.904946,43.6651387 172.468034,30.5408926 176.111942,17.6945718 C177.532449,13.0316043 178.922075,8.30687575 181.299879,4.04535585 C182.071894,2.59396864 183.276236,1.45138721 184.418818,0.30880579 Z"
            stroke="#F6A2AD"
            fill="#F6A2AD"
          ></path>
          <path
            d="M0.030880579,70.562123 C0.833775633,70.5003619 1.63667069,70.3768396 2.47044632,70.3768396 L36.1302774,70.3768396 C37.5507841,70.562123 39.0330519,70.4386007 40.3917973,71.0562123 C42.3681544,71.8591074 44.1283474,73.2178528 45.4253317,74.9162847 C45.5797346,74.8236429 45.8576598,74.5765983 46.0120627,74.453076 C45.2709288,79.5792521 44.0665862,84.6436671 43.0475271,89.7389626 C41.4108565,97.4899879 39.681544,105.241013 37.5199035,112.899397 C36.1302774,117.655006 34.6788902,122.441496 32.3628468,126.857419 C31.5599517,128.401448 30.3247286,129.698432 28.9351025,130.779252 C28.4101327,130.871894 28.0086852,130.501327 27.5763571,130.223402 C26.1249698,129.296984 25.2911942,127.691194 24.3956574,126.239807 C20.1650181,116.605066 19.7018094,105.951267 17.0769602,95.8841978 C15.7490953,90.8506634 14.1124246,85.8480097 11.7037394,81.2159228 C10.2214717,78.4366707 8.39951749,75.7809409 6.02171291,73.6501809 C4.2615199,72.2296743 2.22340169,71.0870929 0.030880579,70.562123 Z"
            stroke="#F6A2AD"
            fill="#F6A2AD"
          ></path>
          <path
            d="M212.087817,73.7737033 C214.033293,71.5811821 216.936068,70.1915561 219.869723,70.3150784 L245.191797,70.3150784 C248.712183,70.3768396 252.26345,70.1915561 255.783836,70.4077201 C254.733896,71.1179735 253.467793,71.3958987 252.356092,71.9826297 C248.496019,73.7428227 245.191797,76.6764777 243.091918,80.3512666 C239.725935,86.2185766 238.552473,92.9505428 237.564294,99.5589867 C236.576116,106.043908 236.606996,112.744994 234.507117,119.044632 C233.08661,123.460555 230.92497,127.907358 227.18842,130.810133 C215.577322,130.933655 203.966224,130.841013 192.386007,130.871894 C191.613993,130.871894 190.872859,130.902774 190.131725,130.748372 C191.799276,130.007238 193.312425,128.895537 194.424125,127.44415 C196.771049,124.417853 198.191556,120.835706 199.365018,117.222678 C200.939928,112.343546 202.082509,107.310012 202.916285,102.245597 C203.997105,95.7915561 205.263209,89.3066345 207.208685,83.037877 C207.826297,81.277684 208.258625,79.4248492 209.370326,77.8808203 C210.296743,76.5220748 210.914355,74.9471653 212.087817,73.7737033 Z"
            stroke="#EB7077"
            fill="#EB7077"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const Antd = () => {
  return (
    <svg viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          x1="62.1023273%"
          y1="0%"
          x2="108.19718%"
          y2="37.8635764%"
          id="linearGradient-1"
        >
          <stop stopColor="#4285EB" offset="0%"></stop>
          <stop stopColor="#2EC7FF" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="69.644116%"
          y1="0%"
          x2="54.0428975%"
          y2="108.456714%"
          id="linearGradient-2"
        >
          <stop stopColor="#29CDFF" offset="0%"></stop>
          <stop stopColor="#148EFF" offset="37.8600687%"></stop>
          <stop stopColor="#0A60FF" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="69.6908165%"
          y1="-12.9743587%"
          x2="16.7228981%"
          y2="117.391248%"
          id="linearGradient-3"
        >
          <stop stopColor="#FA816E" offset="0%"></stop>
          <stop stopColor="#F74A5C" offset="41.472606%"></stop>
          <stop stopColor="#F51D2C" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="68.1279872%"
          y1="-35.6905737%"
          x2="30.4400914%"
          y2="114.942679%"
          id="linearGradient-4"
        >
          <stop stopColor="#FA8E7D" offset="0%"></stop>
          <stop stopColor="#F74A5C" offset="51.2635191%"></stop>
          <stop stopColor="#F51D2C" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="logo" transform="translate(-20.000000, -20.000000)">
          <g id="Group-28-Copy-5" transform="translate(20.000000, 20.000000)">
            <g id="Group-27-Copy-3">
              <g id="Group-25" fillRule="nonzero">
                <g id="2">
                  <path
                    d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C99.2571609,26.9692191 101.032305,26.9692191 102.20193,28.1378823 L129.985225,55.8983314 C134.193707,60.1033528 141.017005,60.1033528 145.225487,55.8983314 C149.433969,51.69331 149.433969,44.8756232 145.225487,40.6706018 L108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                    id="Shape"
                    fill="url(#linearGradient-1)"
                  ></path>
                  <path
                    d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C100.999864,25.6271836 105.751642,20.541824 112.729652,19.3524487 C117.915585,18.4685261 123.585219,20.4140239 129.738554,25.1889424 C125.624663,21.0784292 118.571995,14.0340304 108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                    id="Shape"
                    fill="url(#linearGradient-2)"
                  ></path>
                </g>
                <path
                  d="M153.685633,135.854579 C157.894115,140.0596 164.717412,140.0596 168.925894,135.854579 L195.959977,108.842726 C200.659183,104.147384 200.659183,96.5636133 195.960527,91.8688194 L168.690777,64.7181159 C164.472332,60.5180858 157.646868,60.5241425 153.435895,64.7316526 C149.227413,68.936674 149.227413,75.7543607 153.435895,79.9593821 L171.854035,98.3623765 C173.02366,99.5310396 173.02366,101.304724 171.854035,102.473387 L153.685633,120.626849 C149.47715,124.83187 149.47715,131.649557 153.685633,135.854579 Z"
                  id="Shape"
                  fill="url(#linearGradient-3)"
                ></path>
              </g>
              <ellipse
                id="Combined-Shape"
                fill="url(#linearGradient-4)"
                cx="100.519339"
                cy="100.436681"
                rx="23.6001926"
                ry="23.580786"
              ></ellipse>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Css3 = () => {
  return (
    <svg viewBox="0 0 362.73401 511.99998" id="svg3476" version="1.1">
      <polygon
        id="polygon2989"
        points="437.367,100.62 404.321,470.819 255.778,512 107.644,470.877 74.633,100.62 "
        fill="#264de4"
      />
      <polygon
        id="polygon2991"
        points="376.03,447.246 404.27,130.894 256,130.894 256,480.523 "
        fill="#2965f1"
      />
      <polygon
        id="polygon2993"
        points="150.31,268.217 154.38,313.627 256,313.627 256,268.217 "
        fill="#ebebeb"
      />
      <polygon
        id="polygon2995"
        points="256,176.305 255.843,176.305 142.132,176.305 146.26,221.716 256,221.716 "
        fill="#ebebeb"
      />
      <polygon
        id="polygon2997"
        points="256,433.399 256,386.153 255.801,386.206 205.227,372.55 201.994,336.333 177.419,336.333 156.409,336.333 162.771,407.634 255.791,433.457 "
        fill="#ebebeb"
      />
      <path id="path2999" d="m 160,0 55,0 0,23 -32,0 0,23 32,0 0,23 -55,0 z" />
      <path
        id="path3001"
        d="m 226,0 55,0 0,20 -32,0 0,4 32,0 0,46 -55,0 0,-21 32,0 0,-4 -32,0 z"
      />
      <path
        id="path3003"
        d="m 292,0 55,0 0,20 -32,0 0,4 32,0 0,46 -55,0 0,-21 32,0 0,-4 -32,0 z"
      />
      <polygon
        id="polygon3005"
        points="311.761,313.627 306.49,372.521 255.843,386.191 255.843,433.435 348.937,407.634 349.62,399.962 360.291,280.411 361.399,268.217 369.597,176.305 255.843,176.305 255.843,221.716 319.831,221.716 315.699,268.217 255.843,268.217 255.843,313.627 "
        fill="#ffffff"
      />
    </svg>
  );
};
export const Figma = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 7.678 7.68"
      width="100%"
      height="50px"
    >
      <path
        d="M2.56 7.68A1.28 1.28 0 0 0 3.84 6.4V5.12H2.56a1.28 1.28 0 0 0 0 2.56z"
        fill="#0acf83"
      />
      <path
        d="M1.28 3.84a1.28 1.28 0 0 1 1.28-1.28h1.28v2.56H2.56a1.28 1.28 0 0 1-1.28-1.28z"
        fill="#a259ff"
      />
      <path
        d="M1.28 1.28A1.28 1.28 0 0 1 2.559 0h1.28v2.56H2.56a1.28 1.28 0 0 1-1.28-1.28z"
        fill="#f24e1e"
      />
      <path d="M3.84 0h1.28a1.28 1.28 0 0 1 0 2.56H3.84z" fill="#ff7262" />
      <path
        d="M6.4 3.84a1.28 1.28 0 0 1-2.56 0 1.28 1.28 0 0 1 2.56 0z"
        fill="#1abcfe"
      />
    </svg>
  );
};
export const StyledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 318 318"
      width="100%"
      height="50px"
    >
      <g fill="none" fillRule="evenodd">
        <use stroke="#4A4A4A" strokeWidth="8" mask="url(#b)" s />

        <text
          fill="#000"
          font-family="AppleColorEmoji, Apple Color Emoji"
          font-size="100"
          letter-spacing=".5"
          transform="translate(38 44)"
        >
          <tspan x="70" y="100">
            &lt; / &gt;
          </tspan>
        </text>
      </g>
    </svg>
  );
};
export const Framer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 15"
      width="100%"
      height="50px"
    >
      <path d="M0 14V1l6.5 6.5L13 1v13l-3.25-3.25L6.5 14l-3.25-3.25z"></path>
    </svg>
  );
};
export const Redux = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill="#764ABC">
        <path d="M65.6 65.4c2.9-.3 5.1-2.8 5-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 1.5.7 2.8 1.6 3.7-3.4 6.7-8.6 11.6-16.4 15.7-5.3 2.8-10.8 3.8-16.3 3.1-4.5-.6-8-2.6-10.2-5.9-3.2-4.9-3.5-10.2-.8-15.5 1.9-3.8 4.9-6.6 6.8-8-.4-1.3-1-3.5-1.3-5.1-14.5 10.5-13 24.7-8.6 31.4 3.3 5 10 8.1 17.4 8.1 2 0 4-.2 6-.7 12.8-2.5 22.5-10.1 28-21.4z" />
        <path d="M83.2 53c-7.6-8.9-18.8-13.8-31.6-13.8H50c-.9-1.8-2.8-3-4.9-3h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 3 2.6 5.4 5.6 5.4h.2c2.2-.1 4.1-1.5 4.9-3.4H52c7.6 0 14.8 2.2 21.3 6.5 5 3.3 8.6 7.6 10.6 12.8 1.7 4.2 1.6 8.3-.2 11.8-2.8 5.3-7.5 8.2-13.7 8.2-4 0-7.8-1.2-9.8-2.1-1.1 1-3.1 2.6-4.5 3.6 4.3 2 8.7 3.1 12.9 3.1 9.6 0 16.7-5.3 19.4-10.6 2.9-5.8 2.7-15.8-4.8-24.3z" />
        <path d="M32.4 67.1c.1 3 2.6 5.4 5.6 5.4h.2c3.1-.1 5.5-2.7 5.4-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-.2 0-.5 0-.7.1-4.1-6.8-5.8-14.2-5.2-22.2.4-6 2.4-11.2 5.9-15.5 2.9-3.7 8.5-5.5 12.3-5.6 10.6-.2 15.1 13 15.4 18.3 1.3.3 3.5 1 5 1.5-1.2-16.2-11.2-24.6-20.8-24.6-9 0-17.3 6.5-20.6 16.1-4.6 12.8-1.6 25.1 4 34.8-.5.7-.8 1.8-.7 2.9z" />
      </g>
    </svg>
  );
};
export const GitLogo = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      width="100%"
      height="50px"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 97 97"
      enableBackground="new 0 0 97 97"
    >
      <g>
        <path
          fill="#F05133"
          d="M92.71,44.408L52.591,4.291c-2.31-2.311-6.057-2.311-8.369,0l-8.33,8.332L46.459,23.19
      c2.456-0.83,5.272-0.273,7.229,1.685c1.969,1.97,2.521,4.81,1.67,7.275l10.186,10.185c2.465-0.85,5.307-0.3,7.275,1.671
      c2.75,2.75,2.75,7.206,0,9.958c-2.752,2.751-7.208,2.751-9.961,0c-2.068-2.07-2.58-5.11-1.531-7.658l-9.5-9.499v24.997
      c0.67,0.332,1.303,0.774,1.861,1.332c2.75,2.75,2.75,7.206,0,9.959c-2.75,2.749-7.209,2.749-9.957,0c-2.75-2.754-2.75-7.21,0-9.959
      c0.68-0.679,1.467-1.193,2.307-1.537V36.369c-0.84-0.344-1.625-0.853-2.307-1.537c-2.083-2.082-2.584-5.14-1.516-7.698
      L31.798,16.715L4.288,44.222c-2.311,2.313-2.311,6.06,0,8.371l40.121,40.118c2.31,2.311,6.056,2.311,8.369,0L92.71,52.779
      C95.021,50.468,95.021,46.719,92.71,44.408z"
        />
      </g>
    </svg>
  );
};
export const NodeLogo = () => {
  return (
    <svg
      width="100%"
      height="50px"
      viewBox="0 0 256 289"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <g>
        <path
          d="M127.999999,288.463771 C124.024844,288.463771 120.314699,287.403728 116.869564,285.548656 L81.6231884,264.612838 C76.32298,261.697724 78.9730854,260.637682 80.5631458,260.107661 C87.7184259,257.72257 89.0434775,257.192547 96.4637688,252.952381 C97.2587979,252.422361 98.3188405,252.687372 99.1138718,253.217392 L126.144927,269.383024 C127.20497,269.913045 128.530021,269.913045 129.325053,269.383024 L235.064182,208.165634 C236.124225,207.635611 236.654245,206.575571 236.654245,205.250519 L236.654245,83.0807467 C236.654245,81.7556929 236.124225,80.6956526 235.064182,80.1656324 L129.325053,19.2132506 C128.26501,18.6832305 126.939959,18.6832305 126.144927,19.2132506 L20.4057954,80.1656324 C19.3457551,80.6956526 18.8157349,82.0207041 18.8157349,83.0807467 L18.8157349,205.250519 C18.8157349,206.31056 19.3457551,207.635611 20.4057954,208.165634 L49.2919247,224.861286 C64.9275364,232.811595 74.7329196,223.536234 74.7329196,214.260871 L74.7329196,93.681159 C74.7329196,92.0910985 76.0579711,90.5010358 77.9130428,90.5010358 L91.4285716,90.5010358 C93.0186343,90.5010358 94.6086948,91.8260873 94.6086948,93.681159 L94.6086948,214.260871 C94.6086948,235.196689 83.2132512,247.387164 63.3374737,247.387164 C57.2422362,247.387164 52.4720502,247.387164 38.9565214,240.761906 L11.1304347,224.861286 C4.24016581,220.886129 5.68434189e-14,213.46584 5.68434189e-14,205.515528 L5.68434189e-14,83.3457557 C5.68434189e-14,75.3954465 4.24016581,67.9751552 11.1304347,64.0000006 L116.869564,2.78260752 C123.494824,-0.927535841 132.505176,-0.927535841 139.130436,2.78260752 L244.869565,64.0000006 C251.759834,67.9751552 256,75.3954465 256,83.3457557 L256,205.515528 C256,213.46584 251.759834,220.886129 244.869565,224.861286 L139.130436,286.078676 C135.685299,287.668739 131.710145,288.463771 127.999999,288.463771 L127.999999,288.463771 Z M160.596274,204.455488 C114.219461,204.455488 104.679089,183.254659 104.679089,165.233955 C104.679089,163.643893 106.004141,162.053832 107.859212,162.053832 L121.639752,162.053832 C123.229813,162.053832 124.554864,163.113872 124.554864,164.703935 C126.674947,178.749484 132.770187,185.639753 160.861283,185.639753 C183.122154,185.639753 192.662526,180.604556 192.662526,168.67909 C192.662526,161.788821 190.012423,156.753624 155.296065,153.308489 C126.409938,150.393375 108.389235,144.033126 108.389235,120.977226 C108.389235,99.5113875 126.409938,86.7908901 156.621119,86.7908901 C190.542443,86.7908901 207.238095,98.4513472 209.358178,123.89234 C209.358178,124.687371 209.093167,125.482403 208.563147,126.277434 C208.033127,126.807454 207.238095,127.337474 206.443064,127.337474 L192.662526,127.337474 C191.337475,127.337474 190.012423,126.277434 189.747412,124.952382 C186.567289,110.376813 178.351966,105.606625 156.621119,105.606625 C132.240165,105.606625 129.325053,114.086957 129.325053,120.447205 C129.325053,128.132506 132.770187,130.5176 165.631471,134.757766 C198.227744,138.997931 213.598344,145.093169 213.598344,167.884058 C213.333333,191.20497 194.252589,204.455488 160.596274,204.455488 L160.596274,204.455488 Z"
          fill="#539E43"
        ></path>
      </g>
    </svg>
  );
};
export default JsIcon;
